import React from 'react'
import './InventoryImages.css'

function InventoryImage(props) {
    const baseURL = process.env.REACT_APP_MODE === "TEST" ? `${process.env.REACT_APP_API_URL_TEST}` : `${process.env.REACT_APP_API_URL_PROD}`

    const toggleSelected = () => {
        props.onImageSelect(props.image)
    }

    

    if (!!props.image) {
        return (
            <div className={`mb-2 inline-block ${props.isImageSelected ? 'border-selected' : 'border-not-selected'}`} onClick={toggleSelected}>
                <div className={`rel ${props.mode}`}>
                    <img 
                        src={`${baseURL}inventory_images/thumbimage/${props.image.file_name}?inventory_id=${props.image.inventory_id}`} 
                        className='inventory-thumb-image'
                    /> 
                    {!!props.image.markToDelete &&
                    <div className='delete-overlay'>
                        <h5>WILL DELETE</h5>
                    </div>
                    }

                    {!!props.image.markToAdd && 
                    <div className='add-overlay'>
                        <h5>WILL ADD</h5>
                    </div>
                    }
                </div>
            </div>
        )
    } else {
        return null
    }


}

export default InventoryImage
